export const tags = [
  { title: 'AI/ML', slug: 'AIML' },
  { title: 'Web', slug: 'web' },
  { title: 'Mobile', slug: 'mobile' },
  { title: 'UI/UX', slug: 'ui-ux' },
  { title: 'Chat', slug: 'chat' },
  { title: 'Cloud', slug: 'cloud' },
  { title: 'Data Science', slug: 'data science' },
  { title: 'Ecommerce', slug: 'ecommerce' },
  { title: 'Education', slug: 'education' },
  { title: 'Entertainment', slug: 'entertainment' },
  { title: 'Fintech', slug: 'fintech' },
  { title: 'Healthcare', slug: 'healthcare' },
  { title: 'Logistics', slug: 'logistics' },
  { title: 'Travelling', slug: 'travelling' },
];
